import { render, staticRenderFns } from "./dilu-echarts.vue?vue&type=template&id=2f86cf0d&scoped=true&"
import script from "./dilu-echarts.vue?vue&type=script&lang=js&"
export * from "./dilu-echarts.vue?vue&type=script&lang=js&"
import style0 from "./dilu-echarts.vue?vue&type=style&index=0&id=2f86cf0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86cf0d",
  null
  
)

export default component.exports